module.exports = __webpack_public_path__ + "assets1733911544048/img/lan2.eddb60b0.png";